module.exports = __webpack_public_path__ + "img/file-alt-solid.791d4ca0.svg";